export const THEME_MODE_LIST = {
  default: 'default',
  light: 'light',
  dark: 'dark',
};

export const THEME_TYPE_LIST = {
  auto: 'auto',
  custom: 'custom',
};

export const THEME_LIST = {
  light: {
    colorList: {
      primary: '#1ABDD8',
      secondary: '#82868B',
      success: '#28C76F',
      danger: '#EA5455',
      info: '#255FD9',
      warning: '#FF9F43',
      light: '#BABFC7',
      dark: '#4B4B4B',
      system: '#6e6b7b',
      body: '#5E5873',
    },
    fontOptionList: {
      baseSize: '14px',
    },
  },
  dark: {
    colorList: {
      primary: '#1ABDD8',
      secondary: '#82868B',
      success: '#28C76F',
      danger: '#EA5455',
      info: '#255FD9',
      warning: '#FF9F43',
      light: '#BABFC7',
      dark: '#4B4B4B',
      system: '#6e6b7b',
      body: '#5E5873',
    },
    fontOptionList: {
      baseSize: '14px',
    },
  },
};

export const getSeathruTheme = (themeMode) => {
  let theme = THEME_LIST[THEME_MODE_LIST[themeMode]];

  if (themeMode === THEME_MODE_LIST.default) {
    const isOsDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
    theme = isOsDarkMode ? THEME_LIST[THEME_MODE_LIST.dark] : THEME_LIST[THEME_MODE_LIST.light];
  }

  return {
    theme,
    antdThemeConfig: getAntdThemeConfig(theme),
  };
};

const getAntdThemeConfig = (theme) => ({
  theme: {
    primaryColor: theme.colorList.primary,
    // linkColor: '',
    successColor: theme.colorList.success,
    warningColor: theme.colorList.warning,
    errorColor: theme.colorList.danger,
  },
});

// Template config options
const themeConfig = {
  app: {
    appName: 'SeaThru',
    appLogoImage: require('@src/assets/images/logo/logo.png').default,
  },

  layout: {
    isRTL: false,
    skin: 'light', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'boxed', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false,
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white', // BS color options [primary, success, etc]
    },
    footer: {
      type: 'sticky', // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true, // Enable scroll to top button
  },
};

export default themeConfig;
